import { default as Utils } from '../utils/base.Utils.js';

export default class UtilsFormatter {
  static parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }

  static toJSDate(csDate) {
    return new Date(parseInt(csDate.replace('/Date(', '').replace(')/', '')));
  }

  static toJSDateTZ(csDate) {
    let d = csDate.replace('/Date(', '').replace(')/', '');
    let dateTime = parseInt(d.slice(0, 13));
    let offsetMsecs = 0;
    if (d.length > 13) {
      let tz = d.slice(13);
      let tzSign = tz[0] == '+' ? 1 : -1;
      let tzMin = parseInt(tz[tz.length - 2] + tz[tz.length - 1]);
      let tzHour = parseInt(tz[tz.length - 4] + tz[tz.length - 3]);
      offsetMsecs = tzSign * (tzHour * 60 + tzMin) * 60000;
    }
    return new Date(dateTime + offsetMsecs);
  }

  static toCSDate(jsDate) {
    return '/Date(' + jsDate.getTime() + ')/';
  }

  static momentToDayAndMonthAndDate(momentDate, year) {
    let str = Utils.Language.getUserLanguage() == 'it' ? 'dddd DD/MM' : 'dddd MM/DD';
    if (year) {
      str += '/YYYY';
    }
    return momentDate.format(str);
  }

  static getMomentInterval(date, startHour, durationHours) {
    let start = moment(date).set({
      hour: startHour.split(':')[0],
      minute: startHour.split(':')[1],
      second: startHour.split(':')[2],
      millisecond: 0,
    });
    return {
      start: start,
      end: moment(start).add(durationHours, 'hours'),
    };
  }

  static decimalToHex(number) {
    var hex = number.toString(16);
    while (hex.length < 2) {
      hex = '0' + hex;
    }
    return hex;
  }

  static guid() {
    // RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
    // pseudo-random numbers.
    // The algorithm is as follows:
    //     Set the two most significant bits (bits 6 and 7) of the
    //        clock_seq_hi_and_reserved to zero and one, respectively.
    //     Set the four most significant bits (bits 12 through 15) of the
    //        time_hi_and_version field to the 4-bit version number from
    //        Section 4.1.3. Version4
    //     Set all the other bits to randomly (or pseudo-randomly) chosen
    //     values.
    // UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
    // time-low               = 4hexOctet
    // time-mid               = 2hexOctet
    // time-high-and-version  = 2hexOctet
    // clock-seq-and-reserved = hexOctet:
    // clock-seq-low          = hexOctet
    // node                   = 6hexOctet
    // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    // y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
    // y values are 8, 9, A, B
    var cryptoObj = window.crypto || window.msCrypto; // for IE 11
    if (cryptoObj && cryptoObj.getRandomValues) {
      var buffer = new Uint8Array(16);
      cryptoObj.getRandomValues(buffer);
      //buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
      buffer[6] |= 0x40; //buffer[6] | 01000000 will set the 6 bit to 1.
      buffer[6] &= 0x4f; //buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
      //buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
      buffer[8] |= 0x80; //buffer[8] | 10000000 will set the 7 bit to 1.
      buffer[8] &= 0xbf; //buffer[8] & 10111111 will set the 6 bit to 0.
      return (
        UtilsFormatter.decimalToHex(buffer[0]) +
        UtilsFormatter.decimalToHex(buffer[1]) +
        UtilsFormatter.decimalToHex(buffer[2]) +
        UtilsFormatter.decimalToHex(buffer[3]) +
        '-' +
        UtilsFormatter.decimalToHex(buffer[4]) +
        UtilsFormatter.decimalToHex(buffer[5]) +
        '-' +
        UtilsFormatter.decimalToHex(buffer[6]) +
        UtilsFormatter.decimalToHex(buffer[7]) +
        '-' +
        UtilsFormatter.decimalToHex(buffer[8]) +
        UtilsFormatter.decimalToHex(buffer[9]) +
        '-' +
        UtilsFormatter.decimalToHex(buffer[10]) +
        UtilsFormatter.decimalToHex(buffer[11]) +
        UtilsFormatter.decimalToHex(buffer[12]) +
        UtilsFormatter.decimalToHex(buffer[13]) +
        UtilsFormatter.decimalToHex(buffer[14]) +
        UtilsFormatter.decimalToHex(buffer[15])
      );
    } else {
      var guidHolder = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      var hex = '0123456789abcdef';
      var r = 0;
      var guidResponse = '';
      for (var i = 0; i < 36; i++) {
        if (guidHolder[i] !== '-' && guidHolder[i] !== '4') {
          // each x and y needs to be random
          r = (Math.random() * 16) | 0;
        }
        if (guidHolder[i] === 'x') {
          guidResponse += hex[r];
        } else if (guidHolder[i] === 'y') {
          // clock-seq-and-reserved first hex is filtered and remaining hex values are random
          r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
          r |= 0x8; // set pos 3 to 1 as 1???
          guidResponse += hex[r];
        } else {
          guidResponse += guidHolder[i];
        }
      }
      return guidResponse;
    }
  }

  static parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }

  static checkIfWorkingDay(date, momentFormat) {
    try {
      let momentObject = moment(date, momentFormat);
      momentObject.locale('en');
      return momentObject.isValid() && App[momentObject.format('dddd').toLowerCase() + 'Enabled'];
    } catch (error) {}
    return false;
  }

  static isEnabledDay(date) {
    const numInWeek = moment(date).day();
    if (numInWeek >= 0 && numInWeek <= 6) {
      switch (numInWeek) {
        case 0:
          return App.sundayEnabled;
        case 1:
          return App.mondayEnabled;
        case 2:
          return App.tuesdayEnabled;
        case 3:
          return App.wednesdayEnabled;
        case 4:
          return App.thursdayEnabled;
        case 5:
          return App.fridayEnabled;
        case 6:
          return App.saturdayEnabled;
      }
    }
    return false;
  }

  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  static decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || exp % 1 !== 0) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  // Decimal round
  static round10(value, exp) {
    return UtilsFormatter.decimalAdjust('round', value, exp);
  }
  // Decimal floor
  static floor10(value, exp) {
    return UtilsFormatter.decimalAdjust('floor', value, exp);
  }
  // Decimal ceil
  static ceil10(value, exp) {
    return UtilsFormatter.decimalAdjust('ceil', value, exp);
  }

  static round10Raw(value, exp = 1) {
    return Math.round(value * 10 ** exp) / 10 ** exp;
  }

  static removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0; ) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
  }
}
